var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "blocks" }, [
        _c(
          "div",
          {
            staticClass:
              "l-m-b-20 align-items-center d-flex justify-content-between"
          },
          [
            _c(
              "div",
              { staticClass: "d-flex align-items-center title-search" },
              [
                _c("h1", { staticClass: "pr-3" }, [_vm._v("Tags")]),
                _vm._v(" "),
                _c("div", { staticClass: "input-group search" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn input-group-btn",
                      attrs: { type: "button" },
                      on: { click: _vm.clearSearch }
                    },
                    [
                      _c("i", {
                        class: [_vm.q ? "fa fa-remove" : "fa fa-search"]
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.q,
                        expression: "q"
                      }
                    ],
                    staticClass: "form-control search-input",
                    attrs: { type: "text", placeholder: "Search" },
                    domProps: { value: _vm.q },
                    on: {
                      keyup: function($event) {
                        _vm.searchText($event)
                      },
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.q = $event.target.value
                      }
                    }
                  })
                ])
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "col-3 text-right pr-0" }, [
              _vm.$_can("tags.create")
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-primary btn-schedule",
                      on: { click: _vm.openAddTag }
                    },
                    [_vm._v("\n          Add tag\n        ")]
                  )
                : _vm._e()
            ])
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "row mobile-hidden" }, [
          _c("div", { staticClass: "col-11 filters-field" }, [
            _c("span", [_vm._v("Filters:")]),
            _vm._v(" "),
            _vm.filters.company
              ? _c("span", [
                  _c("span", { staticClass: "filter-item btn btn-filter" }, [
                    _c("span", {
                      staticClass: "mod-icon-filter",
                      on: {
                        click: function($event) {
                          _vm.removeFilter("company")
                        }
                      }
                    }),
                    _vm._v(
                      "\n            Company: " +
                        _vm._s(
                          _vm.companies.find(function(el) {
                            return el.id === _vm.filters.company
                          }).name
                        )
                    )
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-secondary add-filters",
                on: {
                  click: function($event) {
                    _vm.showFilters = true
                  }
                }
              },
              [_c("i", { staticClass: "fa fa-plus filter-icon" })]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-1 d-flex justify-content-end" }, [
            _c("div", { staticClass: "dropdown" }, [
              _c(
                "button",
                {
                  staticClass:
                    "btn btn-secondary sort-button sort-button-selected",
                  attrs: {
                    id: "dropdownMenuButton",
                    "data-toggle": "dropdown",
                    "aria-haspopup": "true",
                    "aria-expanded": "false"
                  },
                  on: {
                    click: function(e) {
                      return e.stopPropagation()
                    }
                  }
                },
                [
                  _vm.selectedKey && _vm.selectedKey.length
                    ? _c("i", {
                        staticClass: "fa pr-2",
                        class: [
                          _vm.ascOrDesc === "asc"
                            ? "fa-sort-amount-asc"
                            : "fa-sort-amount-desc"
                        ]
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.selectedKey === "created_at"
                    ? _c("span", [
                        _vm._v("\n              Created date\n            ")
                      ])
                    : _c("span", [
                        _vm._v("\n              Sort by\n            ")
                      ]),
                  _vm._v(" "),
                  _c("i", { staticClass: "fa fa-caret-down caret" })
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "dropdown-menu sort-dropdown dropdown-menu-right",
                  attrs: { "aria-labelledby": "dropdownMenuButton" }
                },
                [
                  _c(
                    "button",
                    {
                      staticClass:
                        "dropdown-item sort-dropdown-item nav-link btn",
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          _vm.sortBy("created_at")
                        }
                      }
                    },
                    [
                      _c(
                        "span",
                        {
                          class: [
                            _vm.selectedKey === "created_at" ? "selected" : ""
                          ]
                        },
                        [
                          _vm._v(
                            "\n                Created date\n              "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("span", [
                        _vm.selectedKey === "created_at"
                          ? _c("i", {
                              staticClass: "fa",
                              class: [
                                _vm.ascOrDesc === "asc"
                                  ? "fa-sort-amount-asc"
                                  : "fa-sort-amount-desc"
                              ]
                            })
                          : _vm._e()
                      ])
                    ]
                  )
                ]
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      !_vm.tags
        ? [
            _c(
              "vue-content-loading",
              { attrs: { width: 800, height: 450 } },
              _vm._l(15, function(x) {
                return _c("rect", {
                  key: x,
                  attrs: {
                    x: "10",
                    y: 15 * x * 1.4,
                    rx: "5",
                    ry: "5",
                    width: "720",
                    height: "6"
                  }
                })
              })
            )
          ]
        : [
            _c("div", [
              _c(
                "div",
                { staticClass: "blocks" },
                _vm._l(_vm.tags, function(tag, ind) {
                  return _c(
                    "div",
                    {
                      key: ind,
                      staticClass:
                        "w-100 d-flex align-items-center justify-content-between bg-white rounded p-2 mt-3",
                      on: {
                        click: function($event) {
                          if ($event.target !== $event.currentTarget) {
                            return null
                          }
                          _vm.openEditTag(tag)
                        }
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "mr-3 d-flex justify-content-center",
                          staticStyle: { "min-width": "100px" },
                          on: {
                            click: function($event) {
                              if ($event.target !== $event.currentTarget) {
                                return null
                              }
                              _vm.openEditTag(tag)
                            }
                          }
                        },
                        [
                          _c("tag-color", {
                            attrs: {
                              color: tag.color.name,
                              name: tag.name,
                              "input-class": "w-auto"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      tag.companies.length > 4
                        ? [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex align-items-center justify-content-start flex-wrap",
                                on: {
                                  click: function($event) {
                                    if (
                                      $event.target !== $event.currentTarget
                                    ) {
                                      return null
                                    }
                                    _vm.openEditTag(tag)
                                  }
                                }
                              },
                              [
                                _vm._l(tag.companies, function(company, index) {
                                  return _c("span", { key: index }, [
                                    _vm._v(
                                      _vm._s(
                                        index !== 4 && tag.companies.length > 1
                                          ? company.name + ", "
                                          : company.name
                                      ) + " "
                                    )
                                  ])
                                }),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(" and "),
                                  _c("b", [
                                    _vm._v(
                                      _vm._s(tag.companies.length - 4) + " more"
                                    )
                                  ])
                                ])
                              ],
                              2
                            )
                          ]
                        : [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex align-items-center justify-content-start flex-wrap",
                                on: {
                                  click: function($event) {
                                    if (
                                      $event.target !== $event.currentTarget
                                    ) {
                                      return null
                                    }
                                    _vm.openEditTag(tag)
                                  }
                                }
                              },
                              _vm._l(tag.companies, function(company, index) {
                                return _c("span", { key: index }, [
                                  _vm._v(
                                    _vm._s(
                                      index !== 4 &&
                                      tag.companies.length > 1 &&
                                      index !== tag.companies.length - 1
                                        ? company.name + ", "
                                        : company.name
                                    ) + " "
                                  )
                                ])
                              })
                            )
                          ],
                      _vm._v(" "),
                      _vm.$_can("tags.update") || _vm.$_can("tags.delete")
                        ? _c("div", { staticClass: "dropdown" }, [
                            _c("button", {
                              staticClass: "btn btn-secondary add-filter",
                              attrs: {
                                type: "button",
                                id: "dropdownMenuButton" + ind,
                                "data-toggle": "dropdown",
                                "aria-haspopup": "true",
                                "aria-expanded": "false"
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "dropdown-menu dropdown-menu-right",
                                attrs: {
                                  "aria-labelledby": "dropdownMenuButton" + ind
                                }
                              },
                              [
                                _vm.$_can("tags.update")
                                  ? _c(
                                      "button",
                                      {
                                        staticClass:
                                          "dropdown-item nav-link btn",
                                        on: {
                                          click: function($event) {
                                            _vm.openEditTag(tag)
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                Edit Tag\n              "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.$_can("tags.delete")
                                  ? _c(
                                      "button",
                                      {
                                        staticClass:
                                          "dropdown-item nav-link btn",
                                        on: {
                                          click: function($event) {
                                            _vm.tagDelete = tag
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                Remove Tag\n              "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            )
                          ])
                        : _vm._e()
                    ],
                    2
                  )
                })
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "row blocks" },
                [
                  _vm.meta.total
                    ? _c(
                        "div",
                        { staticClass: "col-sm-6 mb-1 pl-0 text-black-50" },
                        [
                          _vm._v(
                            "\n          Showing " +
                              _vm._s(_vm.meta.from) +
                              " - " +
                              _vm._s(_vm.meta.to) +
                              " of " +
                              _vm._s(_vm.meta.total) +
                              "\n        "
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("pagination", {
                    staticClass: "col-sm-6 mb-1 pr-0",
                    attrs: { "change-page": _vm.changePage, meta: _vm.meta }
                  })
                ],
                1
              )
            ])
          ],
      _vm._v(" "),
      _c("transition", { attrs: { name: "slide-fade" } }, [
        _vm.showFilters
          ? _c(
              "div",
              {
                staticClass: "l-modal-mask",
                on: {
                  click: function($event) {
                    if ($event.target !== $event.currentTarget) {
                      return null
                    }
                    _vm.showFilters = false
                  }
                }
              },
              [
                _vm.showFilters
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "filters-side-modal flex flex-column justify-content-start"
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "pointer",
                            on: {
                              click: function($event) {
                                _vm.showFilters = !_vm.showFilters
                              }
                            }
                          },
                          [
                            _c("h1", { staticClass: "modal-h1 l-m-b-20" }, [
                              _c("span", { staticClass: "btn btn-back" }),
                              _vm._v("Add Filter")
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", [
                          _c("p", [
                            _vm._v(
                              "\n            Filters are applied automatically. You can remove them one by one with minus button or with clear filters button.\n          "
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "l-bg-white" }, [
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col" }, [
                              _c("div", { staticClass: "row filters" }, [
                                _vm.companies && _vm.companies.length
                                  ? _c("div", { staticClass: "col-12" }, [
                                      _c(
                                        "div",
                                        { staticClass: "select-wrap" },
                                        [
                                          _c("label", [_vm._v("Companies")]),
                                          _vm._v(" "),
                                          _c("simple-select", {
                                            attrs: {
                                              options: _vm.companies,
                                              "input-id": "status-select",
                                              placeholder: "Select Company"
                                            },
                                            on: { input: _vm.triggerSearch },
                                            model: {
                                              value: _vm.filters.company,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.filters,
                                                  "company",
                                                  $$v
                                                )
                                              },
                                              expression: "filters.company"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ])
                                  : _vm._e()
                              ])
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "row mt-auto" }, [
                          _c("div", { staticClass: "col" }, [
                            _vm.filters.company
                              ? _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-not-active text-dark w-100",
                                    attrs: { type: "button" },
                                    on: { click: _vm.clearFilters }
                                  },
                                  [
                                    _vm._v(
                                      "\n              Clear filters\n            "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ])
                        ])
                      ]
                    )
                  : _vm._e()
              ]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("transition", { attrs: { name: "slide-fade" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showAddTag,
                expression: "showAddTag"
              }
            ],
            staticClass: "l-modal-mask",
            on: {
              click: function($event) {
                if ($event.target !== $event.currentTarget) {
                  return null
                }
                return _vm.closeAddTag($event)
              }
            }
          },
          [
            _c("div", { staticClass: "sidebar-right" }, [
              _c("div", { staticClass: "tag-form-wrapper" }, [
                _c("div", { staticClass: "w-100" }, [
                  _c("h1", { staticClass: "modal-h1 mb-3" }, [
                    _c("button", {
                      staticClass: "btn btn-back",
                      attrs: { type: "button" },
                      on: { click: _vm.closeAddTag }
                    }),
                    _vm._v("\n              Add Tag\n            ")
                  ]),
                  _vm._v(" "),
                  _c(
                    "form",
                    {
                      staticClass: "form-right",
                      attrs: { autocomplete: "no" },
                      on: {
                        submit: function($event) {
                          $event.preventDefault()
                          return _vm.saveAddTag($event)
                        },
                        keydown: function($event) {
                          _vm.clearError($event)
                        }
                      }
                    },
                    [
                      _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          { staticClass: "col-6 p-1" },
                          [
                            _c("div", { staticClass: "select-wrap" }, [
                              _c("label", [_vm._v("Name: ")]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.addTag.name,
                                    expression: "addTag.name"
                                  }
                                ],
                                staticClass: "form-control",
                                attrs: {
                                  type: "text",
                                  placeholder: "Enter Name",
                                  maxlength: "100"
                                },
                                domProps: { value: _vm.addTag.name },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.addTag,
                                      "name",
                                      $event.target.value
                                    )
                                  }
                                }
                              })
                            ]),
                            _vm._v(" "),
                            _c("error-field", {
                              attrs: { errors: _vm.errors, field: "name" }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-6 p-1" },
                          [
                            _c(
                              "div",
                              { staticClass: "select-wrap" },
                              [
                                _c("label", [_vm._v("Color:")]),
                                _vm._v(" "),
                                _vm.colors.length
                                  ? _c("simple-select", {
                                      attrs: {
                                        "hide-deselect": true,
                                        options: _vm.colors,
                                        placeholder: "Select"
                                      },
                                      on: {
                                        input: function($event) {
                                          _vm.errors.clear("tag_color_id")
                                        }
                                      },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "selected_option",
                                          fn: function(props) {
                                            return [
                                              props.value
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "pt-2 mt-1 pl-2 pb-1",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          props.openList()
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _c("tag-color", {
                                                        attrs: {
                                                          color:
                                                            props.value.name,
                                                          "input-class": "w-50"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c("input", {
                                                ref: "search",
                                                staticClass:
                                                  "simple-select-input",
                                                attrs: {
                                                  type: "text",
                                                  placeholder: props.value
                                                    ? ""
                                                    : "Select"
                                                },
                                                on: {
                                                  focus: function($event) {
                                                    props.openList()
                                                  },
                                                  blur: function($event) {
                                                    props.closeList()
                                                  },
                                                  keyup: props.change,
                                                  change: props.change
                                                }
                                              })
                                            ]
                                          }
                                        },
                                        {
                                          key: "option",
                                          fn: function(props) {
                                            return [
                                              _c(
                                                "div",
                                                { staticClass: "option__desc" },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "option__title"
                                                    },
                                                    [
                                                      _c("tag-color", {
                                                        attrs: {
                                                          color:
                                                            props.option.name
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ]
                                              )
                                            ]
                                          }
                                        }
                                      ]),
                                      model: {
                                        value: _vm.addTag.color,
                                        callback: function($$v) {
                                          _vm.$set(_vm.addTag, "color", $$v)
                                        },
                                        expression: "addTag.color"
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("error-field", {
                              attrs: {
                                errors: _vm.errors,
                                field: "tag_color_id"
                              }
                            })
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          { staticClass: "col-12 p-1" },
                          [
                            _c(
                              "div",
                              { staticClass: "select-wrap" },
                              [
                                _c("label", [_vm._v("Companies: ")]),
                                _vm._v(" "),
                                _vm.companies
                                  ? _c("multiselect", {
                                      staticClass: "w-100",
                                      attrs: {
                                        options: _vm.companies,
                                        multiple: true,
                                        "track-by": "name",
                                        label: "name"
                                      },
                                      on: {
                                        input: function($event) {
                                          _vm.errors.clear("companies")
                                        }
                                      },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "tag",
                                          fn: function(props) {
                                            return [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "multiselect__tag"
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(props.option.name)
                                                    )
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("span", {
                                                    staticClass:
                                                      "multiselect__tag-icon",
                                                    on: {
                                                      click: function($event) {
                                                        props.remove(
                                                          props.option
                                                        )
                                                      }
                                                    }
                                                  })
                                                ]
                                              )
                                            ]
                                          }
                                        },
                                        {
                                          key: "option",
                                          fn: function(props) {
                                            return [
                                              _c(
                                                "div",
                                                { staticClass: "option__desc" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "d-flex align-items-center justify-content-between"
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "option__title"
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                              " +
                                                              _vm._s(
                                                                props.option
                                                                  .name
                                                              ) +
                                                              "\n                            "
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          }
                                        }
                                      ]),
                                      model: {
                                        value: _vm.addTag.companies,
                                        callback: function($$v) {
                                          _vm.$set(_vm.addTag, "companies", $$v)
                                        },
                                        expression: "addTag.companies"
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("error-field", {
                              attrs: { errors: _vm.errors, field: "companies" }
                            })
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "buttons-down text-right" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-secondary",
                            attrs: { type: "button" },
                            on: { click: _vm.closeAddTag }
                          },
                          [
                            _vm._v(
                              "\n                  Cancel\n                "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-primary ld-ext-right",
                            class: _vm.loadingButton ? "running" : "",
                            attrs: { disabled: _vm.buttonDisabled }
                          },
                          [
                            _vm._v(
                              "\n                  Create\n                  "
                            ),
                            _c("span", { staticClass: "ld ld-ball ld-flip" })
                          ]
                        )
                      ])
                    ]
                  )
                ])
              ])
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _c("transition", { attrs: { name: "slide-fade" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showEditTag,
                expression: "showEditTag"
              }
            ],
            staticClass: "l-modal-mask",
            on: {
              click: function($event) {
                if ($event.target !== $event.currentTarget) {
                  return null
                }
                return _vm.closeEditTag($event)
              }
            }
          },
          [
            _c("div", { staticClass: "sidebar-right" }, [
              _c("div", { staticClass: "tag-form-wrapper" }, [
                _c("div", { staticClass: "w-100" }, [
                  _c("h1", { staticClass: "modal-h1 mb-3" }, [
                    _c("button", {
                      staticClass: "btn btn-back",
                      attrs: { type: "button" },
                      on: { click: _vm.closeEditTag }
                    }),
                    _vm._v("\n              Update Tag\n            ")
                  ]),
                  _vm._v(" "),
                  _vm.editTag
                    ? _c(
                        "form",
                        {
                          staticClass: "form-right",
                          attrs: { autocomplete: "no" },
                          on: {
                            submit: function($event) {
                              $event.preventDefault()
                              return _vm.saveEditTag($event)
                            },
                            keydown: function($event) {
                              _vm.clearError($event)
                            }
                          }
                        },
                        [
                          _c("div", { staticClass: "row" }, [
                            _c(
                              "div",
                              { staticClass: "col-6 p-1" },
                              [
                                _c("div", { staticClass: "select-wrap" }, [
                                  _c("label", [_vm._v("Name: ")]),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.editTag.name,
                                        expression: "editTag.name"
                                      }
                                    ],
                                    staticClass: "form-control",
                                    attrs: {
                                      type: "text",
                                      placeholder: "Enter Name",
                                      maxlength: "100"
                                    },
                                    domProps: { value: _vm.editTag.name },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          _vm.editTag,
                                          "name",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  })
                                ]),
                                _vm._v(" "),
                                _c("error-field", {
                                  attrs: { errors: _vm.errors, field: "name" }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "col-6 p-1" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "select-wrap" },
                                  [
                                    _c("label", [_vm._v("Color:")]),
                                    _vm._v(" "),
                                    _vm.colors.length
                                      ? _c("simple-select", {
                                          attrs: {
                                            "hide-deselect": true,
                                            options: _vm.colors,
                                            placeholder: "Select"
                                          },
                                          on: {
                                            input: function($event) {
                                              _vm.errors.clear("tag_color_id")
                                            }
                                          },
                                          scopedSlots: _vm._u([
                                            {
                                              key: "selected_option",
                                              fn: function(props) {
                                                return [
                                                  props.value
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "pt-2 mt-1 pl-2 pb-1",
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              props.openList()
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c("tag-color", {
                                                            attrs: {
                                                              color:
                                                                props.value
                                                                  .name,
                                                              "input-class":
                                                                "w-50"
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _c("input", {
                                                    ref: "search",
                                                    staticClass:
                                                      "simple-select-input",
                                                    attrs: {
                                                      type: "text",
                                                      placeholder: props.value
                                                        ? ""
                                                        : "Select"
                                                    },
                                                    on: {
                                                      focus: function($event) {
                                                        props.openList()
                                                      },
                                                      blur: function($event) {
                                                        props.closeList()
                                                      },
                                                      keyup: props.change,
                                                      change: props.change
                                                    }
                                                  })
                                                ]
                                              }
                                            },
                                            {
                                              key: "option",
                                              fn: function(props) {
                                                return [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "option__desc"
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "option__title"
                                                        },
                                                        [
                                                          _c("tag-color", {
                                                            attrs: {
                                                              color:
                                                                props.option
                                                                  .name
                                                            }
                                                          })
                                                        ],
                                                        1
                                                      )
                                                    ]
                                                  )
                                                ]
                                              }
                                            }
                                          ]),
                                          model: {
                                            value: _vm.editTag.color.id,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.editTag.color,
                                                "id",
                                                $$v
                                              )
                                            },
                                            expression: "editTag.color.id"
                                          }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("error-field", {
                                  attrs: {
                                    errors: _vm.errors,
                                    field: "tag_color_id"
                                  }
                                })
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "row" }, [
                            _c(
                              "div",
                              { staticClass: "col-12 p-1" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "select-wrap" },
                                  [
                                    _c("label", [_vm._v("Companies:")]),
                                    _vm._v(" "),
                                    _vm.companies
                                      ? _c("multiselect", {
                                          staticClass: "w-100",
                                          attrs: {
                                            options: _vm.companies,
                                            multiple: true,
                                            "track-by": "name",
                                            label: "name"
                                          },
                                          on: {
                                            input: function($event) {
                                              _vm.errors.clear("companies")
                                            }
                                          },
                                          scopedSlots: _vm._u([
                                            {
                                              key: "tag",
                                              fn: function(props) {
                                                return [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "multiselect__tag"
                                                    },
                                                    [
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            props.option.name
                                                          )
                                                        )
                                                      ]),
                                                      _vm._v(" "),
                                                      _c("span", {
                                                        staticClass:
                                                          "multiselect__tag-icon",
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            props.remove(
                                                              props.option
                                                            )
                                                          }
                                                        }
                                                      })
                                                    ]
                                                  )
                                                ]
                                              }
                                            },
                                            {
                                              key: "option",
                                              fn: function(props) {
                                                return [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "option__desc"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "d-flex align-items-center justify-content-between"
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "option__title"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                              " +
                                                                  _vm._s(
                                                                    props.option
                                                                      .name
                                                                  ) +
                                                                  "\n                            "
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              }
                                            }
                                          ]),
                                          model: {
                                            value: _vm.editTag.companies,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.editTag,
                                                "companies",
                                                $$v
                                              )
                                            },
                                            expression: "editTag.companies"
                                          }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("error-field", {
                                  attrs: {
                                    errors: _vm.errors,
                                    field: "companies"
                                  }
                                })
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "buttons-down text-right" },
                            [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-delete float-left",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function($event) {
                                      _vm.tagDelete = _vm.originalEditTag
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                  Delete\n                "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-secondary",
                                  attrs: { type: "button" },
                                  on: { click: _vm.closeEditTag }
                                },
                                [
                                  _vm._v(
                                    "\n                  Cancel\n                "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-primary ld-ext-right",
                                  class: _vm.loadingButton ? "running" : "",
                                  attrs: { disabled: _vm.buttonDisabled }
                                },
                                [
                                  _vm._v(
                                    "\n                  Update\n                  "
                                  ),
                                  _c("span", {
                                    staticClass: "ld ld-ball ld-flip"
                                  })
                                ]
                              )
                            ]
                          )
                        ]
                      )
                    : _vm._e()
                ])
              ])
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _vm.tagDelete !== null
        ? _c(
            "modal",
            {
              on: {
                close: function($event) {
                  _vm.tagDelete = null
                }
              }
            },
            [
              _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                _c(
                  "h4",
                  {
                    staticClass:
                      "text-black-50 d-flex align-items-center justify-content-start"
                  },
                  [
                    _vm._v("Delete Tag: "),
                    _c("tag-color", {
                      attrs: {
                        name: _vm.tagDelete.name,
                        color: _vm.tagDelete.color.name,
                        "input-class": "ml-3"
                      }
                    })
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("div", { attrs: { slot: "body" }, slot: "body" }, [
                _c("p", { staticClass: "text-center" }, [
                  _vm._v(
                    "Are you sure you want to delete tag with name " +
                      _vm._s(_vm.tagDelete.name) +
                      "?"
                  )
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "text-center",
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-success",
                      on: { click: _vm.removeTag }
                    },
                    [_vm._v("Yes")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-danger",
                      on: {
                        click: function($event) {
                          _vm.tagDelete = null
                        }
                      }
                    },
                    [_vm._v("No")]
                  )
                ]
              )
            ]
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6a2d69f3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a2d69f3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/Tags/Tags.vue
// module id = null
// module chunks = 